module.exports = __webpack_public_path__ + "img/logo-inner).7672ba82.png";